<template>
  <div>
    <div class="resource-select ta-right" v-show="selectableDataTypes.length > 1">
      <span class="ib vm lbl">レイヤーデータ:</span>
      <select v-model="state.selectedDataType" class="custom-select">
        <option v-for="e in selectableDataTypes" :key="e.name" :value="e.name">
          {{e.dispName}}
        </option>
      </select>
    </div>
    <div v-if="state.elemConv && state.elemConv.dataName">
      <component
        :is="currentElemInfoComponent"
        :elem="state.elemConv"
        :is-create-single-new-element="true"
        :force-show-cancel-button="forceShowCancelButton"
        :create-failed="createFailed"
        @update="onChildComponentUpdate"
        @cancel-edit="$emit('cancel-edit')"
      >
      </component>
    </div>
  </div>
</template>

<script setup lang="ts">
import MapElemInfoComment from './MapElemInfoComment.vue';
import {
  computed,
  onMounted,
  reactive,
  watch,
} from 'vue';
import type { MapElemInfo } from 'src/models';
import type { GeoItemMeta } from 'src/models/geoItem';
import type { NewMapElemData } from 'src/models/geoItemSearch';

interface MapElemInfoCommentElement extends MapElemInfo<NewMapElemData> {
  candidateImages: Blob[];
}

interface MapElemInfoNewState {
  selectedDataType: string;
  elemConv: MapElemInfoCommentElement | null;
}

// `:is="'map-elem-info-comment'"` の文字列ベース動的コンポーネント解決に必要
defineOptions({ components: { MapElemInfoComment } });
// withDefaultsでdefaultを与えても、TS上optional(?)でないとrequired:trueのままになるVueの仕様
// https://github.com/vuejs/core/blob/v3.5.35/packages/compiler-sfc/src/script/resolveType.ts (required: !e.optional)
// visibleLayers/createFailedは全呼び出し元が渡しているため必須のまま。forceShowCancelButtonはTop.vueの動的コンポーネント呼び出しが渡していないためoptionalのまま
interface Props {
  elem: MapElemInfoCommentElement;
  visibleLayers: GeoItemMeta[];
  forceShowCancelButton?: boolean;
  createFailed: number;
}
const props = withDefaults(defineProps<Props>(), {
  forceShowCancelButton: false,
});
const emit = defineEmits(['create', 'cancel-edit']);

const state = reactive<MapElemInfoNewState>({
  selectedDataType: '',
  elemConv: null,
});
const initDisplay = () => {
  const creatableLayers = props.visibleLayers.filter(e => e.isCreatable);
  state.selectedDataType = creatableLayers.length > 0 ? creatableLayers[0].name : '';
  if (props.elem) {
    state.elemConv = {
      dataName: state.selectedDataType,
      data: props.elem.data,
      candidateImages: props.elem.candidateImages,
    };
  }
};

onMounted(initDisplay);

watch(() => props.elem, initDisplay);
watch(() => props.visibleLayers, () => {
  const arr = props.visibleLayers.map(e => e.name);
  if (!arr.includes(state.selectedDataType)) {
    initDisplay();
  }
});

const currentElemInfoComponent = computed(() => {
  if (!state.elemConv) return '';

  return 'map-elem-info-' + state.elemConv.dataName;
});
const selectableDataTypes = computed(() => {
  return props.visibleLayers.filter(e => e.isCreatable).map(e => {
    return { name: e.name, dispName: e.dispName };
  });
});

const onChildComponentUpdate = (obj: MapElemInfoCommentElement) => {
  // イベント種別を変換して投げ直す
  emit('create', obj);
};
</script>

<style lang="scss" scoped>
.lbl {
  margin-right: 4px;
}
.resource-select {
  padding: 4px 8px;
  .custom-select {
    width: 140px;
  }
}
</style>
